export const SETTING_TYPES = {
  '1': {
    id: 1,
    name: 'Boolean'
  },
  '2': {
    id: 2,
    name: 'Number'
  },
};